// extracted by mini-css-extract-plugin
export default {"ActionList":"suggestions-list-module__ActionList__NMr6kC6"};